import React from "react";
import PageLayoutWithSidebarWrapper from "./style";

const PageLayoutWithSidebar = (props) =>{

    return(
        <PageLayoutWithSidebarWrapper className={"layout " + props.className}>
            {props.children}
        </PageLayoutWithSidebarWrapper>
    );
};

export default PageLayoutWithSidebar;